import {
  IntegrationChannelType,
  SlackChannelInput,
  useUpdateIntegrationMutation,
} from 'generated/graphql';
import { UUID } from 'v2/core/entities/uuid';
import { getUpdateSlackAndEmailIntegrationInput } from '../utils/getUpdateSlackAndEmailIntegrationInput';
import { isValidUpdateOutboundIntegrationInput } from '../utils/isValidUpdateOutboundIntegrationInput';

export const useUpdateSlackAndEmailOutboundIntegration = () => {
  const [updateIntegrationMutation, { loading: isLoading }] =
    useUpdateIntegrationMutation();

  const updateOutboundIntegration = async (
    channelType: IntegrationChannelType,
    integrationID: UUID,
    slackChannels: SlackChannelInput[],
    emails: string[],
  ) => {
    if (!isValidUpdateOutboundIntegrationInput(channelType)) {
      return;
    }

    await updateIntegrationMutation({
      variables: {
        integrationID,
        isActive: true,
        updateData: getUpdateSlackAndEmailIntegrationInput(
          channelType,
          slackChannels,
          emails,
        ),
      },
    });
  };

  return {
    updateOutboundIntegration,
    isLoading,
  };
};
